import { jsx as _jsx } from "react/jsx-runtime";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackSeoBannerSignUpToShopCtaClick } from "@faire/web-api--source/events/seo/click/bannerSignUpToShopCta";
import React from "react";
import { useHistory } from "react-router-dom";
import { getTotalBrandCount } from "@faire/retailer-visitor-shared/lib/getMarketingCount";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { popSignUp, SignUpElement, SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
var LinkFormatting = function(chunks, handleSignUp) {
    return /*#__PURE__*/ _jsx(EmbeddedLink, {
        onClick: handleSignUp,
        children: chunks
    });
};
export var BrandsCountBanner = function() {
    var isTabletAndAbove = useViewport().isTabletAndAbove;
    var history = useHistory();
    var brandCount = getTotalBrandCount();
    var handleSignUp = function() {
        return popSignUp(history, SignUpType.GENERIC, trackSeoBannerSignUpToShopCtaClick, {
            element: SignUpElement.TOP_BANNER,
            sourceId: "brand_count_banner"
        });
    };
    if (!isLoggedInRetailer() && isTabletAndAbove) {
        return /*#__PURE__*/ _jsx(Typography, {
            align: "center",
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "5ZOWGb",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Shop wholesale online from over "
                    },
                    {
                        type: 1,
                        value: "brandCountNumber"
                    },
                    {
                        type: 0,
                        value: " brands. "
                    },
                    {
                        type: 8,
                        value: "LinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Sign up"
                            }
                        ]
                    }
                ],
                values: {
                    brandCountNumber: brandCount,
                    LinkFormatting: function(chunk) {
                        return LinkFormatting(chunk, handleSignUp);
                    }
                }
            })
        });
    }
    return /*#__PURE__*/ _jsx(Typography, {
        align: "center",
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "nihcsY",
            defaultMessage: [
                {
                    type: 0,
                    value: "Shop wholesale online from over "
                },
                {
                    type: 1,
                    value: "brandCount"
                },
                {
                    type: 0,
                    value: " brands."
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                brandCount: brandCount
            })
        })
    });
};
